import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-capacity',
  templateUrl: './capacity.component.html',
  styleUrls: ['./capacity.component.scss']
})
export class CapacityComponent implements OnInit {

  @Output() shareCapacity = new EventEmitter();

  //used for label naming
  @Input() labelName = '';
  // is used when assining guest capacity for creating event as threshold
  @Input() maximumCapacity:number = 0;
  @Input() numberOfGuests:number = 0;

  @Input() canSetReservationLimit: Boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  addSubCapacity(value: number): void {
    let tmp = this.numberOfGuests + value;
    if(this.canSetReservationLimit){
      if(tmp >= 0 && tmp <=this.maximumCapacity) {
        this.numberOfGuests = tmp;
      }
    } else {
      if(tmp >= 0) {
        this.numberOfGuests = tmp;
      }
    }
    this.onCapacityChange();
  }

  onCapacityChange() {
    this.shareCapacity.emit(this.numberOfGuests);
  }
}
